import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'valueFilter',
  pure: false
})
export class ValueFilterPipe implements PipeTransform {

  transform(items: any[], fields: string[], values: string[], filterOut: boolean): any {
    if (!items) { return []; }
    if (!values) { return items; }
    if (filterOut) {
      return items.filter(it => {
        let result = true;
        fields.forEach((value, index, array) => {
          result = result && (it[fields[index]] as string).toLowerCase().indexOf(values[index]) < 0;
        });
        return result;
      });
    } else {
      return items.filter(it => {
        let result = true;
        fields.forEach((value, index, array) => {
          result = result && (it[fields[index]] as string).toLowerCase().indexOf(values[index]) >= 0;
        });
        return result;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/value-filter.pipe.ts